var _defs, _polygon;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeBannerLeftStairs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1920 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #004574;\n        stroke-width: 0px;\n      }\n    "))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1271 929.02 1271 1080 0 1080 0 418.54 203.62 418.54 203.62 502.11 383.68 502.11 383.68 585.15 579.5 585.15 579.5 673.52 590.1 673.52 590.1 674.05 773.1 674.05 773.1 757.62 926.51 757.62 926.51 840.66 1093.38 840.66 1093.38 929.02 1271 929.02"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeBannerLeftStairs);
export default __webpack_public_path__ + "static/media/home-banner-left-stairs.25d0ecdd20c4b9c4315b286d66047048.svg";
export { ForwardRef as ReactComponent };